import { render } from "./wordRightList.vue?vue&type=template&id=24c8e05c"
import script from "./wordRightList.vue?vue&type=script&lang=js"
export * from "./wordRightList.vue?vue&type=script&lang=js"

import "./wordRightList.vue?vue&type=style&index=0&id=24c8e05c&lang=scss"

import exportComponent from "D:\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__